export default {"src":"/login-app/[GIT_HASH]/_next/static/media/palette.5a9ae63c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};